<form [formGroup]="form" nz-form nzLayout="vertical">

	<!-- ─── Top-level ──────────────────────────────────────────────────────── -->
	<div nz-row [nzGutter]="16">
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label nzRequired>Name</nz-form-label>
				<nz-form-control nzErrorTip="Please enter a name">
					<input nz-input formControlName="name" placeholder="e.g. Silver" />
				</nz-form-control>
			</nz-form-item>
		</div>
		<div nz-col [nzSpan]="12">
			<nz-form-item>
				<nz-form-label>Description</nz-form-label>
				<nz-form-control>
					<input nz-input formControlName="description" placeholder="Optional description" />
				</nz-form-control>
			</nz-form-item>
		</div>
	</div>

	<!-- ─── Details ────────────────────────────────────────────────────────── -->
	<nz-divider nzText="Rate Periods" nzOrientation="left"></nz-divider>

	<button nz-button nzType="dashed" nzSize="small" class="mb-2" (click)="addDetail()">+ Add Period</button>

	<nz-table
		[nzData]="detailsArray.controls"
		nzSize="small"
		nzShowPagination="false"
		nzFrontPagination="false"
		[nzScroll]="{ x: '960px' }">
		<thead>
			<tr>
				<th nzWidth="40px"></th>
				<th nzWidth="130px">From Date</th>
				<th nzWidth="130px">To Date</th>
				<th nzWidth="80px">Age From</th>
				<th nzWidth="80px">Age To</th>
				<th nzWidth="140px">Relation</th>
				<th nzWidth="110px">Premium Type</th>
				<th nzWidth="110px">Premium (R)</th>
				<th nzWidth="110px">Benefit (R)</th>
				<th nzWidth="60px"></th>
			</tr>
		</thead>
		<tbody>
			<ng-container *ngFor="let ctrl of detailsArray.controls; let i = index">
				<!-- Detail row -->
				<tr [formGroup]="asGroup(ctrl)">
					<td [nzExpand]="detailExpanded[i]" (nzExpandChange)="detailExpanded[i] = $event"></td>
					<td>
						<nz-date-picker formControlName="fromDate" nzFormat="yyyy-MM-dd" style="width:100%"></nz-date-picker>
					</td>
					<td>
						<nz-date-picker formControlName="toDate" nzFormat="yyyy-MM-dd" style="width:100%"></nz-date-picker>
					</td>
					<td>
						<nz-input-number formControlName="fromAge" [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number>
					</td>
					<td>
						<nz-input-number formControlName="toAge" [nzMin]="0" [nzStep]="1" style="width:100%"></nz-input-number>
					</td>
					<td>
						<nz-select formControlName="relationToMainMember" style="width:100%">
							<nz-option *ngFor="let item of availableRelations" [nzValue]="item" [nzLabel]="item"></nz-option>
						</nz-select>
					</td>
					<td>
						<nz-select formControlName="premiumType" style="width:100%">
							<nz-option *ngFor="let item of availablePremiumTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
						</nz-select>
					</td>
					<td>
						<nz-input-number formControlName="premiumAmount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" style="width:100%"></nz-input-number>
					</td>
					<td>
						<nz-input-number formControlName="benefitAmount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" style="width:100%"></nz-input-number>
					</td>
					<td>
						<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeDetail(i)">
							<span nz-icon nzType="delete"></span>
						</button>
					</td>
				</tr>
				<!-- Commissions sub-row -->
				<tr [nzExpand]="detailExpanded[i]">
					<td colspan="10" style="padding: 0 16px 16px 40px; background: #fafafa;">
						<div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:8px;">
							<strong>Fees</strong>
							<button nz-button nzType="dashed" nzSize="small" (click)="addCommission(i)">+ Add Fee</button>
						</div>
						<nz-table
							[nzData]="getDetailCommissions(i).controls"
							nzSize="small"
							nzShowPagination="false"
							nzFrontPagination="false"
							[nzBordered]="true">
							<thead>
								<tr>
									<th>Recipient</th>
									<th nzWidth="170px">Type</th>
									<th nzWidth="100px">Amount</th>
									<th nzWidth="60px"></th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let cCtrl of getDetailCommissions(i).controls; let j = index" [formGroup]="asGroup(cCtrl)">
									<td>
										<nz-select
											nzShowSearch
											nzAllowClear
											formControlName="recipient"
											style="width:100%"
											nzPlaceHolder="Select recipient"
											[nzLoading]="recipientsLoading"
											[compareWith]="compareById">
											<nz-option
												*ngFor="let r of commissionRecipients"
												[nzValue]="r"
												[nzLabel]="r.name + ' (' + r.type + ')'">
											</nz-option>
										</nz-select>
									</td>
									<td>
										<nz-select formControlName="commissionType">
											<nz-option *ngFor="let item of availableCommissionTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
										</nz-select>
									</td>
									<td>
										<nz-input-number formControlName="commissionAmount" [nzMin]="0" [nzStep]="0.01" [nzPrecision]="2" style="width:100%"></nz-input-number>
									</td>
									<td>
										<button nz-button nzType="text" nzDanger nzSize="small" (click)="removeCommission(i, j)">
											<span nz-icon nzType="delete"></span>
										</button>
									</td>
								</tr>
								<tr *ngIf="getDetailCommissions(i).length === 0">
									<td colspan="4" style="text-align:center; color:#999;">No commissions — click '+ Add Commission'</td>
								</tr>
							</tbody>
						</nz-table>
					</td>
				</tr>
			</ng-container>
		</tbody>
	</nz-table>

	<nz-alert
		*ngIf="detailsArray.length === 0"
		nzType="info"
		nzMessage="No rate periods defined. Click '+ Add Period' to begin."
		class="mt-2">
	</nz-alert>

</form>

<div *nzModalFooter>
	<button nz-button nzType="default" (click)="onCancel()">Cancel</button>
	<button nz-button nzType="primary" [disabled]="form.invalid" (click)="onSave()">Save</button>
</div>
